import styled from "styled-components";
import { ColorTokens, Theme } from "@tvg/design-system";

export const FDTVOverlayContainer = styled.div<{
  theme: Theme;
}>`
  position: absolute;
  top: ${({ theme }) => theme.space["space-2"]};
  right: ${({ theme }) => theme.space["space-4"]};
  display: flex;
  gap: ${({ theme }) => theme.space["space-3"]};
  align-items: center;
`;

export const LiveBadgeText = styled.span<{
  theme: Theme;
  colorTokens: ColorTokens;
}>`
  color: ${({ colorTokens }) =>
    colorTokens.component.button.secondaryDark.content.base};
  border-radius: ${({ theme }) => theme.radii.xs};
  background-color: ${({ colorTokens }) => colorTokens.background.negative};
  font-family: ${({ theme }) => theme.fonts.condensedRegular}, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  line-height: 13.2px;
  text-transform: uppercase;
  padding: 2px ${({ theme }) => theme.space["space-1"]};
`;

export const BalanceBadge = styled.div<{
  theme: Theme;
}>`
  display: flex;
  align-items: center;
  background-color: rgba(10, 10, 10, 0.6);
  gap: ${({ theme }) => theme.space["space-3"]};
  border-radius: ${({ theme }) => theme.radii.xs};
  padding: 7px ${({ theme }) => theme.space["space-3"]};
`;

export const BalanceBadgeText = styled.span<{
  theme: Theme;
  colorTokens: ColorTokens;
}>`
  color: ${({ colorTokens }) =>
    colorTokens.component.button.secondaryDark.content.base};
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.medium}, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.s};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: 17.5px;
`;

export const ResultedBadgeText = styled.span<{
  theme: Theme;
  colorTokens: ColorTokens;
}>`
  color: ${({ colorTokens }) => colorTokens.content.default};
  font-family: ${({ theme }) => theme.fonts.condensedRegular}, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  line-height: 13.2px;
  text-transform: uppercase;
  padding: 2px ${({ theme }) => theme.space["space-1"]};
  border-radius: ${({ theme }) => theme.radii.xs};
  background-color: ${({ colorTokens }) =>
    colorTokens.background.neutralSubtle};
`;
